@for (option of state().options; track option.value) {
	<ctb-radio-button
		[ariaLabel]="option.ariaLabel"
		[checked]="state().value === option.value"
		[disabled]="option.disabled"
		[id]="option.id"
		[label]="option.label"
		[name]="state().name"
		[value]="option.value"
		(selected)="onOptionSelect($event)"
	/>
}
